import { useQuery } from '@tanstack/react-query';
import { analysisService } from '../services/analysis.service';
import type { ListRecordsResponse, Analysis } from '../services/analysis.service';

export function useAnalyses(options?: {
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    filters = {},
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<Analysis>>({
    queryKey: ['analyses', page, pageSize, filters],
    queryFn: () => analysisService.find({ page, pageSize, filters }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

